import React, { useState } from "react";
import styles from "./chat-history.module.css";
import EmptyLoader from "../../../../../../components/emptyloader/emptyloader";
import UserCard from "../user-card/user-card";
import { useChat } from "../../../../../../context/chat-context";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

const ChatHistory = ({
  showNewChat,
  setShowNewChat,
  selectedChat,
  setSelectedChat,
  chatRoles,
}) => {
  const { chatHistory, resetConversation, selectedRole, changeRole, isSupportPath } = useChat();
  const [search, setSearch] = useState("");

  const handleChatSelect = (userInfo) => {
    if (selectedChat?.user_id !== userInfo?.user_id) {
      resetConversation();
      setSelectedChat(userInfo);
    }
  };

  const getDisplayText = (userInfo) => {
    return userInfo?.last_message
      ? userInfo.last_message
      : userInfo?.last_attachment?.length
      ? "📎 Attachment"
      : "No messages yet";
  };

  const filteredData = chatHistory?.filter((u) =>
    u.user_name?.toLowerCase()?.includes(search?.toLowerCase())
  );

  return (
    <>
      <div className={styles["chat-history-header"]}>
        <h3>Recent Chats</h3>
        {!isSupportPath && (
          <Tooltip 
            title={showNewChat ? null : "New Chat"} 
            key={showNewChat ? "no-tooltip" : "with-tooltip"}
          >
            <Button
              type="text"
              icon={<PlusOutlined style={{ color: 'var(--primary-color)', fontSize: "20px" }} />}
              onClick={() => setShowNewChat(true)}
            />
          </Tooltip>
        )}
      </div>

      <CustomTextfield
        id="search"
        placeholder="Search"
        size="large"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles["chat-history-search-bar"]}
        prefix={<SearchOutlined style={{ color: "#98A2B3" }} />}
        allowClear={true}
      />

      <div className={styles["tab-container"]}>
        {["ALL", ...chatRoles]?.map((role) => (
          <Button 
            key={role}
            className={`${styles["tab"]} ${styles[selectedRole === role ? "active" : ""]}`} 
            onClick={() => changeRole(role)}
          >
            {role}
          </Button>
        ))}
      </div>

      <EmptyLoader isDataAvailable={filteredData?.length} />

      <div className={styles["chat-history-list"]}>
        {filteredData?.map((user, index) => (
          <UserCard
            key={index}
            name={user?.user_name || "Unknown User"}
            lastmessage={getDisplayText(user)}
            timeAgo={user?.last_message_at}
            imgUrl={user?.profile_url}
            onClick={() => handleChatSelect(user)}
            active={selectedChat?.user_id === user?.user_id}
            isOnline={user?.isOnline}
            unreadCount={user?.unread_count}
          />
        ))}
      </div>
    </>
  );
};

export default ChatHistory;
